import { AccountDetails, PayloadAccountDetailsMin } from "../services";

/**
 * Transforms AccountDetails to PayloadAccountDetailsMin
 * Used when editing accounts - extracts only the editable fields
 *
 * @param account - The full account details object
 * @returns Payload object with editable account fields
 */
export const toPayloadAccountDetailsMin = (
  account: AccountDetails,
): PayloadAccountDetailsMin => ({
  id: account.id,
  name: account.name,
  accountType: account.accountType,
  institution: account.institution,
  startDate: account.startDate,
  initialBalance: account.initialBalance,
  cashbackMode: account.cashbackMode,
  cashbackRate: account.cashbackRate,
  cashbackMonthlyCap: account.cashbackMonthlyCap,
});
